<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function() {
        return {
        };
    },
    methods: {
    },
    mounted: function() {
    },
}
</script>